import { createLiveContainer, type Container } from "@ezbatna/core"

let container: Container | null = null

export function getContainer(): Container {
  if (!container) {
    container = createLiveContainer({
      recaptchaSiteKey: import.meta.env.VITE_RECAPTCHA_SITE_KEY,
    })
  }
  return container
}
